module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_libao.2727c.png";